import { useQuery } from '@tanstack/react-query';
import QUERY_KEYS from '../utils/QueryKeys';
import { Extra } from '../models';

export default function useRetouchingExtra() {
  return useQuery([QUERY_KEYS.EXTRAS, QUERY_KEYS.RETOUCHING], () => (
    Extra
      .includes('prices')
      .where({ retouching: true })
      .find()
      .then((res) => res.data)
  ));
}
